/**
 * cent to yuan
 * 分转换成元
 * @param cent 待格式化的金额或百分比
 * @param seat 占位符号
 * @returns string
 */
export function CTY(cent: string | number, seat?: string) {
    if (cent === undefined || cent === null) return seat ?? 0;
    return (+cent / 100).toFixed(2);
}
